// Home-page hero copy: the rotating headline (HeroSayings), the search console
// (HeroSearch) and the photo credit line (HomeHero). See src/pages/home/components/.
// Keys must match ar/hero.ts exactly.
const hero = {
  // The page's <h1> for screen readers. The rotating sayings are hidden from them
  // so they are not read again on every change.
  srHeadline: 'Find a property to rent or buy on Safaqat 24',
  // The visible headline, still (2026-10-07): the rotating sayings needed a pause button.
  // Three parts; the middle one in gold (2026-10-08, after rightmove).
  headlineLead: 'Find the',
  headlineAccent: 'best property deal',
  headlineTail: 'for you',
  subtitle: 'Properties for rent and sale across the Kingdom',

  // The rotating headline. Saying 1 is home.v2.hero.dealLead with a rotating city,
  // then these in order. Each one describes a feature the site really has.
  sayings: {
    home: 'Find a home that fits your life.',
    describe: 'Describe the property you want in your own words and we will search for it',
    draw: 'Draw your area on the map and see the properties inside it',
    request: 'Post your request so it reaches real-estate brokers',
    deeds: 'Prices from deals registered with the Ministry of Justice',
    owners: 'Owners: list your property for free and pay commission only when the deal closes',
    // The pause / resume button.
    pause: 'Pause the rotating headline',
    play: 'Resume the rotating headline',
  },

  // The small label over the search bar; it follows the listing type.
  panel: {
    rentLabel: 'Search properties to rent',
    buyLabel: 'Search properties to buy',
  },
  tabs: {
    label: 'Listing type',
    rent: 'For rent',
    buy: 'For sale',
  },
  category: {
    label: 'Category',
    residential: 'Residential',
    commercial: 'Commercial',
  },
  bar: {
    label: 'Property search',
    city: 'City',
    allCities: 'All cities',
    query: 'District, or describe what you want',
    queryPlaceholder: 'Type a district or describe the property you want',
    type: 'Property type',
    search: 'Search',
  },
  // Suggestions under the «district or describe» field.
  suggestions: {
    label: 'Suggested cities and districts',
    city: 'City',
    district: 'District',
  },
  filters: {
    toggle: 'Filters',
    // The button's name for screen readers while some filters are set.
    toggleActive: 'Filters ({{n}} active)',
    panel: 'Search filters',
    clearAll: 'Clear all',
    submit: 'Search',
  },
  map: 'Search on the map',

  // The credit line on the background, while the photo's licence (CC BY-SA) asks for one.
  credit: {
    photo: 'Photo:',
    separator: ', ',
    commons: 'Wikimedia Commons',
    edited: '(edited)',
    newTab: '(opens in a new tab)',
  },
};

export default hero;
